import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  TuiButtonModule,
  TuiDropdownModule,
  TuiSvgModule
} from "@taiga-ui/core";
import { TuiInputFilesModule, TuiMarkerIconModule } from "@taiga-ui/kit";
import { KwikUIInputFilesComponent } from "./input-files.component";
import { KwikUIButtonModule } from "../../button/button.module";

@NgModule({
  declarations: [KwikUIInputFilesComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TuiInputFilesModule,
    TuiMarkerIconModule,
    TuiSvgModule,
    TuiDropdownModule,
    TuiButtonModule,
    KwikUIButtonModule
  ],
  exports: [KwikUIInputFilesComponent]
})
export class KwikUIInputFilesModule {}
